import { Component, inject } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';


import { DialogRef } from '../../dialog/dialog-ref';
import { DialogModule } from '../../dialog/dialog.module';

interface HelpSectionGroup {
  title?: string;
  sections: HelpSection[];
}

interface HelpSection {
  title: string;
}

@Component({
  selector: 'app-rule-help-section-dialog',
  standalone: true,
  templateUrl: './rule-help-section-dialog.component.html',
  styleUrls: ['./rule-help-section-dialog.component.scss'],
  imports: [TranslocoPipe, MatFormFieldModule, MatIconModule, DialogModule],
})
export class RuleHelpSectionDialogComponent {
  expandedSectionTitles: string[] = [];
  helpSectionGroups: HelpSectionGroup[] = [
    {
      sections: [
        {
          title: 'RuleComponents',
        },
      ],
    },
    {
      title: 'SpecialCases',
      sections: [
        {
          title: 'Scores',
        },
      ],
    },
    {
      title: 'FunctionsAndOperators',
      sections: [
        {
          title: 'CompareOperators',
        },
        {
          title: 'LogicalOperators',
        },
        {
          title: 'Functions',
        },
        {
          title: 'TimeParameters',
        },
        {
          title: 'PatientVariables',
        },
        {
          title: 'References',
        },
      ],
    },
  ];

  public dialogRef = inject(DialogRef);
}
